import { IAddSubscription } from "../subscriptionType";
import AddSubscriptionAPI from "./AddSubscriptionAPI";

const AddSubscriptionService = async ({ 
    header, 
    planName, 
    monthlyAmount, 


    policyCount, 
    planDetails, 
    createdBy, 
    userLimit, 
    discount 
}: IAddSubscription): Promise<any> => {
    
    try {
        const res = await AddSubscriptionAPI({
            header, 
            planName, 
            monthlyAmount, 
   
            policyCount, 
            createdBy, 

            planDetails,
            userLimit, // Ensuring userLimit is passed
            discount   // Ensuring discount is passed
        });

        return res;
    } catch (error) {
        throw error;
    }
};

export default AddSubscriptionService;
